import { render, staticRenderFns } from "./LawTypeOfViolationForm.vue?vue&type=template&id=038f901e&"
import script from "./LawTypeOfViolationForm.vue?vue&type=script&lang=js&"
export * from "./LawTypeOfViolationForm.vue?vue&type=script&lang=js&"
import style0 from "./LawTypeOfViolationForm.vue?vue&type=style&index=0&id=038f901e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports